import {
    BackgroundCheckScreeningResult,
    BackgroundCheckScreeningStatus,
    BackgroundCheckScreeningStatusDto,
} from '@clh/api-client';

const STATUS_LABELS: Record<BackgroundCheckScreeningStatus, string> = {
    NOT_STARTED: 'Not started',
    IN_PROGRESS: 'In progress',
    COMPLETE: 'Complete',
    NEEDS_REVIEW: 'Needs review',
    CANCELED: 'Canceled',
};

const RESULT_LABELS: Record<BackgroundCheckScreeningResult, string> = {
    CLEAR: 'Clear',
    NEEDS_REVIEW: 'Needs review',
};

export function screeningResultLabel(
    result: BackgroundCheckScreeningResult | null
): string {
    return result ? RESULT_LABELS[result] : '—';
}

export function screeningStatusLabel({
    status,
    pendingStatus,
}: BackgroundCheckScreeningStatusDto): string {
    return status === BackgroundCheckScreeningStatus.InProgress && pendingStatus
        ? pendingStatus
        : STATUS_LABELS[status];
}
